/**
 * This helper class can save and restore the expanded state of detail rows in a grid.
 * @param grid
 * @constructor
 */
var SavedDetailRow = function(grid) {
    var expanded = grid.tbody.find("tr.k-master-row>td.k-hierarchy-cell>a.k-svg-i-caret-alt-down").parent().parent();
    this.ids = expanded.toArray().map(function(row) {
        return grid.dataItem($(row)).id;
    });
};

SavedDetailRow.prototype.restore = function(grid) {
    this.ids
        .map(function(id) {
            return grid.dataSource.get(id);
        })
        .filter(function(item) {
            return !!item;
        })
        .map(function(item) {
            return grid.tbody.find("tr[data-uid='" + item.uid + "']");
        })
        .filter(function(row) {
            return row && row.length;
        })
        .forEach(function(row) {
            grid.expandRow(row);
        });
};

export default SavedDetailRow;
